// extracted by mini-css-extract-plugin
export default {"recos":"d6-z","productCardOverride":"e6-z","rowHasBadge":"f6-z"};